import keyBy from 'lodash/keyBy';
import uniqueId from 'lodash/uniqueId';

function createWaypoint(waypoint: PartialWaypoint): Waypoint {
    return {
        type: 'Feature',
        properties: {
            title: 'Untitled Waypoint',
            time_created: new Date().toISOString(),
            icon: '',
            ...waypoint.properties,
            writable: true,
            localId: uniqueId(),
            archived: false,
            isLocallyCreated: true,
            type: 'waypoint',
        },
        geometry: waypoint.geometry,
    };
}

export default function (
    action: CreateWaypointAction,
    setWaypoints: React.Dispatch<React.SetStateAction<{[localId: string]: Waypoint}>>
) {
    const data = (Array.isArray(action.data) ? action.data : [action.data]).map((feature) =>
        createWaypoint(feature)
    );

    setWaypoints((latestWaypoints) => ({
        ...latestWaypoints,
        ...keyBy(data, (waypoint) => waypoint.properties.localId),
    }));

    if (action.callback) action.callback(data[0]);
    return data.map((waypoint) => waypoint.properties.localId);
}
